// extracted by mini-css-extract-plugin
module.exports = {"paginationWrapper":"PaginationWrapper_paginationWrapper__1_00p"};